import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { castDraft } from 'immer';

import { ComponentDesign } from '@paragon/contract-library';

interface ComponentDesignsState {
  data: Record<string, ComponentDesign>;

  designsBeingLoaded: Record<string, true>;
  designsFailedToLoad: Record<string, true>;
}

const initialState: ComponentDesignsState = {
  data: {},

  designsBeingLoaded: {},
  designsFailedToLoad: {},
};

export const componentDesignsSlice = createSlice({
  name: 'componentDesigns',
  initialState,
  reducers: {
    beganLoading(state, action: PayloadAction<string[]>) {
      for (const guid of action.payload) {
        delete state.designsFailedToLoad[guid];
        state.designsBeingLoaded[guid] = true;
      }
    },

    loadedFromServer(state, action: PayloadAction<readonly ComponentDesign[]>) {
      for (const design of action.payload) {
        delete state.designsBeingLoaded[design.guid];
        delete state.designsFailedToLoad[design.guid];

        state.data[design.guid] = castDraft(design);
      }
    },

    failedToLoad(state, action: PayloadAction<string[]>) {
      for (const guid of action.payload) {
        delete state.designsBeingLoaded[guid];
        state.designsFailedToLoad[guid] = true;
      }
    },
  },
});
